export const getAccessToken = () => {
    const temporaryAccessToken = sessionStorage.getItem('temporary_access_token');
    const accessToken = localStorage.getItem('access_token');

    if (temporaryAccessToken) return temporaryAccessToken;
    else if (accessToken) return accessToken;
    return '';
}